export default [
  { value: "booking source", text: "Booking source" },
  { value: "paypal", text: "Paypal" },
  { value: "merchant", text: "Merchant" }
];
